import styled from 'styled-components';
import { generateClassNames, applyDisplayNames } from '../../utils/functions';
import StyledInputGroup from '../input-group/input-group.styles';
var baseClassName = 'SelectGroup';
var SelectGroup = /*#__PURE__*/styled(StyledInputGroup.InputGroup).attrs({
  className: generateClassNames(baseClassName, 'root')
}).withConfig({
  componentId: "sc-1uvutwe-0"
})([""]);
var Styled = applyDisplayNames({
  SelectGroup: SelectGroup
});
export default Styled;